export default "__VITE_ASSET__CetlwZfb__"